import { Button } from 'antd'

export const renderEmailLinkColumn = (email: string) => (
  <Button type="link" href={`mailto:${email}`} style={{ paddingLeft: 0 }}>
    {email}
  </Button>
)
